import { slugify } from '@src/utils/slugify';

export const defaultColumnEnhancer = (headers) => {
  //   console.log('headers: ', headers);
  return headers.map((header) => {
    const id = slugify(header.title);

    return {
      accessorKey: header.title,
      id,
      header: header.title,
      tooltip: header.tooltip,
    };
  });
};
